import { SupportedLocale, SupportedLanguagePath } from '@amzn/aws-marketing-experience-builder-template-types';
export const DEFAULT_LOCALE = SupportedLocale.EN_US;
export const SUPPORTED_LOCALE_DATA = {
    'ar-SA': {
        path: SupportedLanguagePath.AR,
    },
    'de-DE': {
        path: SupportedLanguagePath.DE,
    },
    'en-US': { path: SupportedLanguagePath.EN },
    'es-ES': {
        path: SupportedLanguagePath.ES,
    },
    'fr-FR': {
        path: SupportedLanguagePath.FR,
    },
    'ja-JP': { path: SupportedLanguagePath.JP },
    'id-ID': { path: SupportedLanguagePath.ID },
    'ko-KR': { path: SupportedLanguagePath.KO },
    'pt-BR': { path: SupportedLanguagePath.PT },
    'th-TH': { path: SupportedLanguagePath.TH },
    'tr-TR': { path: SupportedLanguagePath.TR },
    'vi-VN': { path: SupportedLanguagePath.VI },
    'zh-CN': {
        path: SupportedLanguagePath.CN,
    },
    'ru-RU': { path: SupportedLanguagePath.RU },
    'zh-TW': {
        path: SupportedLanguagePath.TW,
    },
    'it-IT': { path: SupportedLanguagePath.IT },
};
